import { render, staticRenderFns } from "./CursosTerminados.vue?vue&type=template&id=4e81cd58&scoped=true&"
import script from "./CursosTerminados.vue?vue&type=script&lang=js&"
export * from "./CursosTerminados.vue?vue&type=script&lang=js&"
import style0 from "./CursosTerminados.vue?vue&type=style&index=0&id=4e81cd58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e81cd58",
  null
  
)

export default component.exports